module.exports = __webpack_public_path__ + "img/sd1.8b3763ef.jpg";